import { messagingKeys } from '@/features/messaging/queries';
import { useSessionStore } from '@/state/sessionStore';
import { useTypingStore } from '@/state/typingStore';
import { registerBinding } from './bindings';

import { tNow } from '@/i18n/languageStore';

/**
 * Live chat details from the server (backend MessagingGateway): who is typing, and who came online or went offline.
 * The phone app reads the same events (mobile/src/state/messagingStore.ts).
 */
const isString = (value: unknown): value is string => typeof value === 'string';
const record = (value: unknown) =>
  value && typeof value === 'object' ? (value as Record<string, unknown>) : null;

registerBinding('messaging', 'typing', (payload) => {
  const p = record(payload);
  if (!p || !isString(p.conversationId) || !isString(p.memberId)) return;
  // My other tabs and devices are not "someone typing".
  if (p.memberId === useSessionStore.getState().member?.id) return;
  const typing = useTypingStore.getState();
  if (p.typing === true)
    typing.typingStart(p.conversationId, p.memberId, isString(p.name) ? p.name : tNow('Someone'));
  else typing.typingStop(p.conversationId, p.memberId);
});

registerBinding('messaging', 'presence:changed', (payload, { queryClient }) => {
  const p = record(payload);
  if (!p || !isString(p.memberId) || typeof p.online !== 'boolean') return;
  const { memberId, online } = p as { memberId: string; online: boolean };
  queryClient.setQueryData<{ online: string[] }>(messagingKeys.presence, (current) => {
    const others = (current?.online ?? []).filter((id) => id !== memberId);
    return { online: online ? [...others, memberId] : others };
  });
});
